import { safeStringify } from '../../shared-utilities/safeStringify';

export const closeWebview = ppcCloseEvent => {
    // Legacy web view support.
    if (window && window.venice && typeof window.venice.ppcClose === 'function') {
        return window.venice.ppcClose();
    }

    // Modern web view support.
    if (window && window.paypalMobile && typeof window.paypalMobile.ppcClose === 'function') {
        const ppcClosePayload = {
            event: ppcCloseEvent,
            additionalData: null
        };
        const rawPpcClosePayload = safeStringify(ppcClosePayload);

        return window.paypalMobile.ppcClose(rawPpcClosePayload);
    }
};
